/**
 * Header Component
 */
window.SLDS = window.SLDS || {};
window.SLDS["header"] = function () {
  let lastScrollY = 0;
  let ticking = false;
  const SCROLL_THRESHOLD = 10;

  const updateScrollState = () => {
    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;
    const scrollDelta = Math.abs(currentScrollY - lastScrollY);
    const isNearTop = currentScrollY < 50;
    const anyPanelOpen = this.searchOpen || this.mobileMenuOpen || this.globalModalOpen || this.globalModalMobileOpen;

    if (isNearTop || !isScrollingDown || anyPanelOpen) {
      this.navVisible = true;
    } else if (isScrollingDown && scrollDelta > SCROLL_THRESHOLD && currentScrollY > 50) {
      this.navVisible = false;
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateScrollState.bind(this));
      ticking = true;
    }
  };

  return {
    searchOpen: false,
    mobileMenuOpen: false,
    globalModalOpen: false,
    globalModalMobileOpen: false,
    navVisible: true,

    init() {
      window.addEventListener('scroll', onScroll, { passive: true });
      lastScrollY = window.scrollY;
    },

    destroy() {
      window.removeEventListener('scroll', onScroll);
    },

    toggleSearch() {
      this.searchOpen = !this.searchOpen;
      if (this.searchOpen) {
        this.globalModalOpen = false;
        this.mobileMenuOpen = false;
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },

    toggleGlobalModal() {
      this.globalModalOpen = !this.globalModalOpen;
      if (this.globalModalOpen) {
        this.searchOpen = false;
        this.mobileMenuOpen = false;
      }
    },
  };
};
